"use client";

import React, { FunctionComponent, useEffect, useRef, useState } from "react";

import {
  ICallToAction,
  ICallToActionFields,
  INavItem,
  INavItemFields,
} from "@/types/generated/contentful";
import CallToAction from "../callToAction";
import VerticalDrawer from "./verticalDrawer";

type Props = {
  item: INavItem | ICallToAction;
  closeNav: Function;
  expanded: boolean;
  itemSelected: Function;
};

const MobileNavItem: FunctionComponent<Props> = ({
  item,
  expanded,
  closeNav,
  itemSelected,
}) => {
  const isNavItem = (item.fields as INavItemFields).sections ? true : false;

  if (isNavItem) {
    const content = item.fields as INavItemFields;
    return (
      <li key={item.sys.id}>
        <VerticalDrawer content={content} closeNav={closeNav} />
      </li>
    );
  }

  return (
    <li>
      <CallToAction
        content={item as ICallToAction}
        nav={true}
        appendClass={`${(item.fields as ICallToActionFields).style === "tertiary" ? "!w-fit !text-base" : "!w-full xl:!w-fit"}`}
      />
    </li>
  );
};

export default MobileNavItem;
